export const FullHideIcon = (): JSX.Element => {
  return (
    <div className="flex text-primary-3.0">
      <i className="icon-chevron_left_icon w-2 my-auto font-semibold" />
      <i className="icon-chevron_left_icon w-2 my-auto font-semibold" />
    </div>
  );
};
